export const italianShopIds = [623, 622, 621, 723, 722, 721];
